<script setup>
import { useAttrs } from 'vue';
import drLogo from '../../assets/images/dr-logo.png';

const attrs = useAttrs();
</script>

<template>
  <img v-bind="attrs" :src="drLogo" alt="DR Flow" />
</template>
